import Component from './route-component';
import Enhance from '../core/enhance';
import checkPath from './utils/checkPath';
import React from 'react'

/**
 *
 */
class Route extends Component {

    constructor() {
        super();
    }

    state = {}

    /**
     *shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    shouldComponentUpdate(nextProps, nextState) {
        let {pathname} = this.location();
        let pathname1 = checkPath(pathname);
        let pathname2 = checkPath(nextProps.pathname);
        //路由改变后不再更新
        return pathname1 === pathname2;
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        // console.log('componentDidMount Route');
    }

    /**
     *
     * @return {null}
     */
    render() {
        // console.log('render route');
        const {pathname, hash, params, component, children} = this.props;
        if (children) {
            return React.cloneElement(children, {
                pathname,
                hash,
                params,
                state: window.history.state ? window.history.state.state : {}
            });
        }
        if (component) {
            return React.createElement(component, {
                pathname,
                hash,
                params,
                state: window.history.state ? window.history.state.state : {}
            });
        }
        return null
    }
}

Enhance(Route, {}, 'Route');
export default Route
